import React from 'react';
import style from './style.module.scss';
import { IProps, IHandlers, classPrefix } from './types';
import { Alert, AlertTitle } from '@material-ui/lab';
import MuiAlert from '@material-ui/lab/Alert';
import { Button, withStyles } from '@material-ui/core';
import { renderIf } from 'external-services/react-utils-service/index';
import classNames from 'classnames';
import AppThemeService from 'app/services/theme/appTheme.service';

const NS = 'StandbyConfirmationMsg';

const { palette } = AppThemeService.getAppTheme();

const MainAlert = withStyles({
  filledInfo: {
    backgroundColor: palette.info.dark,
  },
  message: {
    width: '100%',
  },
  icon: {
    alignItems: 'center',
    [`& .${classPrefix}-MuiSvgIcon-root`]: {
      fontSize: 27,
      width: 27,
      height: 27,
    },
  },
})(MuiAlert);

export default function StandbyConfirmationMsg({
  errorMsg,
  isLoading,
  formattedTime,
  standbyConfirmationExpiry,
  bookingExpired,
  handleResendClick,
  handleResetClick,
}: IProps & IHandlers) {
  const standByPendingMsg = `Awaiting customer confirmation for ${formattedTime}. ${
    standbyConfirmationExpiry ? `\nExpires: ${standbyConfirmationExpiry}` : ``
  }`;
  const standByErrorMsg = `Customer link has now expired and can no longer confirm booking online${
    standbyConfirmationExpiry ? ` (expired: ${standbyConfirmationExpiry})` : ''
  }.`;

  const severityType = bookingExpired ? 'error' : 'info';
  const severityMsg = bookingExpired ? standByErrorMsg : standByPendingMsg;

  return (
    <div className={style.root}>
      <MainAlert severity={severityType} variant="filled">
        {severityMsg}
        <div className={style.btnsWrap}>
          <Button
            className={classNames({
              [style.btn]: true,
              [style.btnIsDisabled]: isLoading || bookingExpired,
            })}
            variant="outlined"
            color="default"
            size="medium"
            disabled={isLoading || bookingExpired}
            onClick={handleResendClick}
          >
            Resend
          </Button>

          <Button
            className={classNames({
              [style.btn]: true,
              [style.btnIsDisabled]: isLoading,
            })}
            variant="outlined"
            color="default"
            size="medium"
            disabled={isLoading}
            onClick={handleResetClick}
          >
            Change
          </Button>
        </div>
      </MainAlert>

      {renderIf(errorMsg, () => (
        <div className={style.errorWrap}>
          <Alert severity="error" variant="filled" className={style.errorMsg}>
            {errorMsg}
          </Alert>
        </div>
      ))}
    </div>
  );
}
